var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: {
        width: "100%",
        height: "calc(100vh - 96px)",
        overflow: "hidden",
        "padding-bottom": "15px",
        "box-sizing": "border-box",
      },
    },
    [
      !_vm.isMore
        ? _c(
            "div",
            {
              staticClass: "flex margin-top-15",
              staticStyle: { width: "100%", height: "calc(100% - 15px)" },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "help position-relative margin-x-15 color-bg-fff flex-1",
                  staticStyle: {
                    "box-shadow": "0px 0px 22px 1px rgba(0, 0, 0, 0.08)",
                    height: "100%",
                  },
                },
                [
                  _c("img", {
                    staticStyle: {
                      width: "100%",
                      height: "105px",
                      "border-top-left-radius": "10px",
                      "border-top-right-radius": "10px",
                    },
                    attrs: { src: require("./static/icon_home.jpg") },
                  }),
                  _c("div", { staticClass: "search-box position-absolute" }, [
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "font-light font-18 color-333 margin-left-40 margin-bottom-10",
                        },
                        [_vm._v("在这里，我们为你提供帮助和支持")]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "search color-bg-fff flex-center",
                          on: { click: _vm.search },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-12 color-999 padding-x-10 margin-left-20 flex-1",
                            },
                            [
                              _vm._v(
                                "请输入关键词进行搜索，如班次、订单、订票等"
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "search-btn flex-center",
                              on: { click: _vm.search },
                            },
                            [
                              _c("img", {
                                staticStyle: { width: "24px", height: "24px" },
                                attrs: {
                                  src: require("./static/icon_home_search.png"),
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "flex",
                      staticStyle: {
                        width: "100%",
                        height: "calc(100% - 120px)",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "padding-top-20",
                          staticStyle: { width: "16%" },
                        },
                        [
                          _c(
                            "el-menu",
                            {
                              staticClass: "jumpMenu",
                              staticStyle: {
                                height: "100%",
                                "overflow-y": "auto",
                              },
                              attrs: {
                                "default-active": _vm.activeStep,
                                "active-text-color": "#22C655",
                              },
                              on: { select: _vm.handleSelect },
                            },
                            _vm._l(_vm.typeList, function (item, index) {
                              return _c(
                                "el-menu-item",
                                { key: item.id, attrs: { index: index } },
                                [
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "30px",
                                        height: "30px",
                                      },
                                      attrs: { src: item.icon },
                                    }),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "font-16 margin-left-5",
                                        attrs: { slot: "title" },
                                        slot: "title",
                                      },
                                      [_vm._v(_vm._s(item.name))]
                                    ),
                                  ],
                                ],
                                2
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "flex-1 flex-col margin-top-20 padding-left-10 margin-left-20 scroll_cls",
                          staticStyle: {
                            height: "99%",
                            "overflow-y": "auto",
                            "border-bottom-right-radius": "10px",
                          },
                          attrs: { id: "scroll_cls" },
                          on: { scroll: _vm.onScroll },
                        },
                        _vm._l(_vm.articleList, function (item) {
                          return _c("div", { key: item.id }, [
                            _c("div", { staticClass: "flex-start" }, [
                              item.name
                                ? _c("div", { staticClass: "title-before" })
                                : _vm._e(),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "name-box margin-y-10 scroll-item",
                                },
                                [_vm._v(_vm._s(item.name))]
                              ),
                            ]),
                            item.name
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "flex margin-left-10",
                                    staticStyle: {
                                      width: "calc(100% - 10px)",
                                      "overflow-y": "auto",
                                    },
                                  },
                                  _vm._l(item.tagList, function (tag) {
                                    return _c(
                                      "div",
                                      {
                                        key: tag.id,
                                        staticClass:
                                          "padding-x-20 padding-y-5 font-14 margin-right-10",
                                        class: tag.active
                                          ? "tag-active"
                                          : "tag",
                                        on: {
                                          click: function ($event) {
                                            return _vm.tagClick(item, tag)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(tag.name) +
                                            "\n              "
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            item.name
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "flex flex-wrap",
                                    staticStyle: { width: "100%" },
                                  },
                                  _vm._l(item.articleList, function (article) {
                                    return _c(
                                      "div",
                                      {
                                        key: article.id,
                                        staticClass:
                                          "article padding-10 margin-y-10 flex flex-col flex-justify-between",
                                        on: {
                                          click: function ($event) {
                                            return _vm.goDetail(
                                              article.id,
                                              article.isHot
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "flex-between" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "color-333 font-16 text-eli",
                                                staticStyle: {
                                                  "max-width": "78%",
                                                  "font-weight": "600",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(article.title) +
                                                    "\n                  "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "flex-center" },
                                              [
                                                article.isHot
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "isHat color-fff flex-center font-12 margin-right-5",
                                                      },
                                                      [_vm._v("热")]
                                                    )
                                                  : _vm._e(),
                                                article.isHot
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "color-999 font-12",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            article.pageView
                                                          )
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c("div", {
                                          staticClass:
                                            "color-666 font-14 content",
                                          domProps: {
                                            innerHTML: _vm._s(article.content),
                                          },
                                        }),
                                        _c("div", [
                                          _c("div", {
                                            staticClass: "margin-y-5",
                                            staticStyle: {
                                              "border-bottom":
                                                "1px solid #f1f1f1",
                                              width: "100%",
                                            },
                                          }),
                                          _c(
                                            "div",
                                            { staticClass: "flex-between" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  staticClass:
                                                    "font-14 font-normal padding-y-3",
                                                  staticStyle: {
                                                    color: "#22c655",
                                                  },
                                                  attrs: { type: "text" },
                                                },
                                                [_vm._v("查看详情")]
                                              ),
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-arrow-right font-10 color-666",
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _vm._e(),
                            item.name &&
                            item.pages !== item.current &&
                            item.articleList.length > 0
                              ? _c("div", { staticClass: "flex-center" }, [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-arrow-down color-999 font-light",
                                    staticStyle: { "font-size": "24px" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getMore(item)
                                      },
                                    },
                                  }),
                                ])
                              : _vm._e(),
                          ])
                        }),
                        0
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                { staticClass: "box-card" },
                [
                  _c(
                    "el-card",
                    {
                      staticStyle: {
                        height: "calc(100vh - 125px)",
                        "overflow-y": "auto",
                        "border-radius": "10px",
                        "margin-right": "15px",
                      },
                      attrs: { shadow: "always" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "clearfix flex-between",
                          attrs: { slot: "header" },
                          slot: "header",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "font-20 font-weight flex-start" },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#22c655" } },
                                [_vm._v("公")]
                              ),
                              _c("span", { staticClass: "margin-right-5" }, [
                                _vm._v("告"),
                              ]),
                              _c("img", {
                                staticStyle: {
                                  width: "6.45px",
                                  height: "16.87px",
                                },
                                attrs: {
                                  src: require("./static/icon_home_announcement.png"),
                                },
                              }),
                            ]
                          ),
                          _c(
                            "el-button",
                            {
                              staticClass: "font-normal padding-y-3 font-14",
                              staticStyle: { float: "right", color: "#22c655" },
                              attrs: { type: "text" },
                              on: {
                                click: function ($event) {
                                  _vm.isMore = true
                                },
                              },
                            },
                            [
                              _vm._v("更多 "),
                              _c("i", {
                                staticClass: "el-icon-arrow-right font-12",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.announcementList, function (item) {
                        return _c(
                          "div",
                          {
                            key: item.id,
                            staticClass: "text-item flex-between margin-y-10",
                            on: {
                              click: function ($event) {
                                return _vm.getAnnouncementDetail(item.id)
                              },
                            },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "flex-start flex-1",
                                staticStyle: { width: "60%" },
                              },
                              [
                                item.isTop
                                  ? _c(
                                      "span",
                                      {
                                        staticClass:
                                          "top-title padding-x-5 margin-right-10 font-14",
                                      },
                                      [_vm._v("置顶")]
                                    )
                                  : _vm._e(),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "text-eli title font-14 flex-1",
                                  },
                                  [_vm._v(_vm._s(item.title))]
                                ),
                              ]
                            ),
                            _c("span", { staticClass: "color-999 font-12" }, [
                              _vm._v(
                                _vm._s(
                                  item.publishTime
                                    ? _vm
                                        .dayjsFormat(item.publishTime)
                                        .format("YYYY-MM-DD")
                                    : ""
                                )
                              ),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]
          )
        : _c(
            "div",
            {
              staticClass: "padding-20 color-bg-fff margin-x-10 full-y",
              staticStyle: {
                "box-sizing": "border-box",
                width: "100%",
                overflow: "auto",
              },
            },
            [
              _c(
                "div",
                { staticClass: "padding-10 font-18" },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "font-size": "18px" },
                      attrs: { type: "text", icon: "el-icon-d-arrow-left" },
                      on: {
                        click: function ($event) {
                          _vm.isMore = false
                        },
                      },
                    },
                    [_vm._v("返回")]
                  ),
                  _c("span", { staticClass: "margin-left-10" }, [
                    _vm._v("最新公告"),
                  ]),
                ],
                1
              ),
              _c(
                "el-table",
                { attrs: { data: _vm.announcementList, border: "" } },
                [
                  _c("el-table-column", {
                    attrs: { prop: "title", label: "公告标题", width: "1000" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "text-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.getAnnouncementDetail(
                                      scope.row.id
                                    )
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "flex-start flex-1",
                                    staticStyle: { width: "70%" },
                                  },
                                  [
                                    scope.row.isTop
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "top-title padding-x-5 margin-right-10 font-14",
                                          },
                                          [_vm._v("置顶")]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      { staticClass: "text-eli title font-14" },
                                      [_vm._v(_vm._s(scope.row.title))]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { prop: "isRead", label: "状态", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              { class: scope.row.isRead ? "" : "red-text" },
                              [
                                _vm._v(
                                  _vm._s(scope.row.isRead ? "已查看" : "待查看")
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "right",
                    "margin-right": "20px",
                    "margin-top": "20px",
                  },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.announcementPagination.current,
                      "page-sizes": [15, 20, 50, 100],
                      "page-size": _vm.announcementPagination.size,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
      _c("announcement-dialog", {
        ref: "announcementDialog",
        on: { close: _vm.handleClose },
      }),
      _c("LicenseExpireWarning", {
        ref: "licenseEcpireWarning",
        on: { close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }